module.exports = __webpack_public_path__ + "media/images/logo/payment_channel/qris-b5772b5e96c20b21c2c46ebe03d09896.svg";